import { Button } from '@/components/ui/button.jsx'
import { observer } from 'mobx-react-lite'
import PromeetLogo from '@/assets/images/promeet-logo.svg?react' // eslint-disable-line import/no-unresolved
import { cn } from '@/utils/ui.js'
import { Link } from '@tanstack/react-router'
import Icon from '@mdi/react'
import {
  iconDiscord,
  iconInstagram,
  iconLinkedin,
  iconReddit,
  iconTikTok,
  iconX,
  iconYoutube,
} from '@/components/ui/customIcons.js'
import { mdiEmail } from '@mdi/js'

const SocialLink = observer(({ className, children, iconPath, iconSize = 1, ...props }) => {
  props.rel = 'noopener'
  props.target = '_blank'

  return (
    <Button
      asChild
      className={cn('text-muted-foreground hover:text-foreground xxs:basis-0 basis-1/4', className)}
      size="icon"
      variant="ghost">
      <Link {...props}>{children || <Icon path={iconPath} size={iconSize} />}</Link>
    </Button>
  )
})

const PromeetClosedError = ({ ...props }) => (
  <div {...props} className="flex grow flex-col items-center justify-center gap-12 p-3">
    <PromeetLogo className="h-auto w-full max-w-64 dark:fill-white" />

    <div className="text-center">
      <h1 className="text-2xl">We are closed for now</h1>
      <h2 className="mt-2 text-lg">And will come back in the future</h2>
    </div>

    <div className="flex flex-wrap justify-center gap-6">
      <SocialLink iconPath={mdiEmail} to="mailto:help@promeet.live" />
      <SocialLink iconPath={iconDiscord} to={import.meta.env.VITE_SOCIAL_DISCORD} />
      <SocialLink iconPath={iconX} to={import.meta.env.VITE_SOCIAL_X} />
      <SocialLink iconPath={iconReddit} to={import.meta.env.VITE_SOCIAL_REDDIT} />
      <SocialLink iconPath={iconYoutube} to={import.meta.env.VITE_SOCIAL_YOUTUBE} />
      <SocialLink iconPath={iconInstagram} to={import.meta.env.VITE_SOCIAL_INSTAGRAM} />
      <SocialLink iconPath={iconTikTok} to={import.meta.env.VITE_SOCIAL_TIKTOK} />
      <SocialLink iconPath={iconLinkedin} to={import.meta.env.VITE_SOCIAL_LINKEDIN} />
    </div>
  </div>
)

export default observer(PromeetClosedError)
